import { initContract } from '@ts-rest/core';
import { z } from 'zod';
////////////////////////////////////////////////////////////////////////////////
// getFiledClaims
////////////////////////////////////////////////////////////////////////////////
export const FiledClaim = z.strictObject({
    id: z.string(),
    claimNumber: z.string(),
    status: z.string().nullable(),
    contractNumber: z.string().nullable(),
    policyHolder: z.string().nullable(),
    divisionHeader: z.string().nullable(),
    risk: z.string().nullable(),
    objectHeader: z.string().nullable(),
    reportDate: z.string().nullable(),
    claimDate: z.string().nullable(),
    incidentLocation: z.string().nullable(),
    claimType: z.string().nullable(),
    claimAmountEur: z.number().nullable(),
    deductibleEur: z.number().nullable(),
    quoteCount: z.number().nullable(),
    quoteAmountEur: z.number().nullable(),
    invoiceCount: z.number().nullable(),
    invoiceAmountEur: z.number().nullable(),
    selfRepairCount: z.number().nullable(),
    selfRepairAmountEur: z.number().nullable(),
    totalPayoutEur: z.number().nullable(),
});
export const GetFiledClaimsQuery = z.strictObject({
    year: z.number().int(),
    dateField: z.enum(['reportDate', 'claimDate']),
});
export const GetFiledClaimsResponse = z.strictObject({
    claims: z.array(FiledClaim),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const filedClaimsContract = c.router({
    getFiledClaims: {
        method: 'GET',
        path: '/get-filed-claims',
        query: GetFiledClaimsQuery,
        responses: {
            200: GetFiledClaimsResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/filed-claims' });
